// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policiessection-inline-1 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.policiessection-inline-2 {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
}

.policiessection-inline-3 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.policiessection-inline-4 {
  padding: 16px;
}

.policiessection-inline-5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.policiessection-inline-6 {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 4px;
}

.policiessection-inline-7 {
  font-size: 11px;
  color: #64748b;
  margin-bottom: 6px;
}

.policiessection-inline-8 {
  font-size: 12px;
  color: #475569;
  line-height: 1.5;
}

.policiessection-inline-9 {
  font-size: 11px;
  padding: 6px 12px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/PoliciesSection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".policiessection-inline-1 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.policiessection-inline-2 {\n  text-align: center;\n  padding: 30px;\n  color: #94a3b8;\n}\n\n.policiessection-inline-3 {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.policiessection-inline-4 {\n  padding: 16px;\n}\n\n.policiessection-inline-5 {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.policiessection-inline-6 {\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.policiessection-inline-7 {\n  font-size: 11px;\n  color: #64748b;\n  margin-bottom: 6px;\n}\n\n.policiessection-inline-8 {\n  font-size: 12px;\n  color: #475569;\n  line-height: 1.5;\n}\n\n.policiessection-inline-9 {\n  font-size: 11px;\n  padding: 6px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
